import React from "react";

import { ButtonStandard, ModalBase, Text } from "@performyard/py-components";

import { useReopenCompensationCycle } from "../../../../api/hooks/defs/compensation";

type ReopenCycleModalProps = {
	cycleId: string;
	closeModal: () => void;
};

const ReopenCycleModal: React.FC<ReopenCycleModalProps> = ({ cycleId, closeModal }) => {
	const { mutate: reopenCycle, isPending } = useReopenCompensationCycle();

	const handleReopenCycle = () => {
		reopenCycle(cycleId, {
			onSuccess: () => {
				closeModal();
			},
		});
	};

	return (
		<ModalBase isOpen onClose={closeModal} dangerouslySetClassName="!overflow-hidden w-[416px] min-h-[164px]">
			<div className="flex flex-col items-center px-6 pb-6">
				<div className="flex w-full flex-col items-center text-center">
					<Text size="sub-heading" weight="semi-bold">
						Reopen Cycle
					</Text>
					<div className="mx-auto max-w-[384px]">
						<Text size="paragraph-3" weight="regular">
							This action will re-open the compensation cycle and make all budgets editable again. Any
							finalized budget values may be changed after reopening.
						</Text>
					</div>
				</div>
				<div className="mt-6 flex flex-row items-center justify-center gap-2">
					<ButtonStandard variant="outline" color="neutral" size="large" onClick={closeModal}>
						Cancel
					</ButtonStandard>
					<ButtonStandard
						variant="solid"
						color="primary"
						size="large"
						onClick={handleReopenCycle}
						disabled={isPending}
					>
						Yes, Reopen Cycle
					</ButtonStandard>
				</div>
			</div>
		</ModalBase>
	);
};

export default ReopenCycleModal;
